import type { XAxisProps } from "recharts";

const CATEGORY_AXIS_TICK_CLASS = "fill-muted-foreground text-xxs";

export interface CategoryAxisTickProps {
  x: number | string;
  y: number | string;
  payload: {
    value: string | number;
    coordinate: number;
    index: number;
  };
  tickFormatter?: XAxisProps["tickFormatter"];
  index: number;
  className?: string;
}

/** -45° end-anchored category axis tick for dense or long labels. */
export const RotatedCategoryAxisTick = ({
  x,
  y,
  payload,
  tickFormatter,
  index,
  className = CATEGORY_AXIS_TICK_CLASS,
}: CategoryAxisTickProps) => (
  <text
    x={x}
    y={y}
    dy={10}
    textAnchor="end"
    transform={`rotate(-45, ${x}, ${y})`}
    className={className}
  >
    {tickFormatter ? tickFormatter(payload.value, index) : payload.value}
  </text>
);
